import script from "./CurrencyPairList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrencyPairList.vue?vue&type=script&setup=true&lang=ts"

import "./CurrencyPairList.vue?vue&type=style&index=0&id=6e9330e4&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9330e4"]])

export default __exports__